export default __webpack_public_path__ + "static/media/wattlogic-1-10.cbe36800.png";